import {
  isISOCountryCode,
  ISOCountryCode,
  parseCountryCode,
} from '@foundation/countries';

export type TUiPattern = 'dd-MM-yyyy' | 'yyyy-MM-dd' | 'MM-dd-yyyy';

// Countries that use the Year-Month-Day date format (yyyy-MM-dd)
// Primarily used in East Asia, parts of Central/Eastern Europe, and Scandinavia
// (Big-Endian / ISO 8601)
const YMD_COUNTRIES = new Set([
  ISOCountryCode.China,
  ISOCountryCode.Japan,
  ISOCountryCode.SouthKorea,
  ISOCountryCode.NorthKorea,
  ISOCountryCode.Taiwan,
  ISOCountryCode.Mongolia,
  ISOCountryCode.Hungary,
  ISOCountryCode.Lithuania,
  ISOCountryCode.Sweden,
  ISOCountryCode.Iran,
  ISOCountryCode.Bhutan,
]);

// Countries that use the Month-Day-Year date format (MM-dd-yyyy)
// Primarily used in the United States and a few other countries
// (Middle-Endian)
const MDY_COUNTRIES = new Set([
  ISOCountryCode.UnitedStatesAmerica,
  ISOCountryCode.Philippines,
  ISOCountryCode.Micronesia,
  ISOCountryCode.MarshallIslands,
  ISOCountryCode.Palau,
  ISOCountryCode.AmericanSamoa,
  ISOCountryCode.Guam,
  ISOCountryCode.NorthernMarianaIslands,
  ISOCountryCode.PuertoRico,
  ISOCountryCode.VirginIslandsUS,
]);

export function getDatePatternByCountry(countryCode: string): TUiPattern {
  if (isISOCountryCode(countryCode)) {
    const isoCountryCode = parseCountryCode(countryCode);

    if (YMD_COUNTRIES.has(isoCountryCode)) {
      return 'yyyy-MM-dd';
    }

    if (MDY_COUNTRIES.has(isoCountryCode)) {
      return 'MM-dd-yyyy';
    }
  }

  // The vast majority of the world uses dd-MM-yyyy (Little-Endian).
  return 'dd-MM-yyyy';
}
